import MSfCurrentUserStatus from './index.vue';

MSfCurrentUserStatus.install = app => {
  app.component(MSfCurrentUserStatus.name, MSfCurrentUserStatus);
};

export default MSfCurrentUserStatus;
